namespace RioERP.Orders {
    export interface OrdersForm {
        OrderDate: Serenity.DateEditor;
        OrderNumber: Serenity.StringEditor;
        ESourceType: Serenity.EnumEditor;
        Mode: Serenity.LookupEditor;
        Level: Serenity.LookupEditor;
        SourceName: Serenity.StringEditor;
        SourceOrderNumber: Serenity.StringEditor;
        FranchiseeId: Serenity.LookupEditor;
        VendorId: Serenity.LookupEditor;
        CustomerId: Serenity.LookupEditor;
        CustomerName1: Serenity.StringEditor;
        InvoiceCompanyId: Serenity.LookupEditor;
        CustomerEmail1: Serenity.EmailEditor;
        CustomerEmail2: Serenity.EmailEditor;
        CustomerMobile11: Serenity.StringEditor;
        CustomerMobile21: Serenity.StringEditor;
        EInvoiceTo: Serenity.EnumEditor;
        EInvoiceStatus: Serenity.EnumEditor;
        EOrderStatus: Serenity.EnumEditor;
        ShippingProviderId: Serenity.LookupEditor;
        ShippingAddress1: Serenity.StringEditor;
        ShippingAddress2: Serenity.StringEditor;
        ShippingCity: Serenity.StringEditor;
        ShippingStateId: Serenity.LookupEditor;
        ShippingCountry: Serenity.StringEditor;
        ShippingPincode: Serenity.IntegerEditor;
        EShippingType: Serenity.EnumEditor;
        EOrderProcessBy: Serenity.EnumEditor;
        EShippingStatus: Serenity.EnumEditor;
        ShippingToName: Serenity.StringEditor;
        ExpectedShippingDate: Serenity.DateEditor;
        ShippingNote: Serenity.TextAreaEditor;
        BillingAddress1: Serenity.StringEditor;
        BillingAddress2: Serenity.StringEditor;
        BillingCity: Serenity.StringEditor;
        BillingStateId: Serenity.LookupEditor;
        BillingCountry: Serenity.StringEditor;
        BillingPincode: Serenity.IntegerEditor;
        OrderProducts: OrderProductsEditor;
        GrossAmount: Serenity.DecimalEditor;
        DiscountAmount: Serenity.DecimalEditor;
        NetAmount: Serenity.DecimalEditor;
        NetAmountAfterFrDiscount: Serenity.DecimalEditor;
        TaxableAmount: Serenity.DecimalEditor;
        TaxAmount: Serenity.DecimalEditor;
        DiscountCoupon: Serenity.StringEditor;
        EFranchiseeDiscountType: Serenity.EnumEditor;
        EFranchiseeDiscount: Serenity.EnumEditor;
        FranchiseeDiscountValue: Serenity.DecimalEditor;
        FranchiseeDiscountAmount: Serenity.DecimalEditor;
        EPaymentStatus: Serenity.EnumEditor;
        EPaymentType: Serenity.EnumEditor;
        Gstin: Serenity.StringEditor;
        Note: Serenity.TextAreaEditor;
        EmailSendCount: Serenity.IntegerEditor;
        OrderInstallments: OrderInstallmentEditor;
        HasBooks: Serenity.BooleanEditor;
        MailId: Serenity.StringEditor;
        CurrencyId: Serenity.LookupEditor;
        IsEmailSent: Serenity.BooleanEditor;
        LastEmailSentDate: Serenity.DateEditor;
        FreezeData: Serenity.BooleanEditor;
    }

    export class OrdersForm extends Serenity.PrefixedContext {
        static formKey = 'Orders.Orders';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!OrdersForm.init)  {
                OrdersForm.init = true;

                var s = Serenity;
                var w0 = s.DateEditor;
                var w1 = s.StringEditor;
                var w2 = s.EnumEditor;
                var w3 = s.LookupEditor;
                var w4 = s.EmailEditor;
                var w5 = s.IntegerEditor;
                var w6 = s.TextAreaEditor;
                var w7 = OrderProductsEditor;
                var w8 = s.DecimalEditor;
                var w9 = OrderInstallmentEditor;
                var w10 = s.BooleanEditor;

                Q.initFormType(OrdersForm, [
                    'OrderDate', w0,
                    'OrderNumber', w1,
                    'ESourceType', w2,
                    'Mode', w3,
                    'Level', w3,
                    'SourceName', w1,
                    'SourceOrderNumber', w1,
                    'FranchiseeId', w3,
                    'VendorId', w3,
                    'CustomerId', w3,
                    'CustomerName1', w1,
                    'InvoiceCompanyId', w3,
                    'CustomerEmail1', w4,
                    'CustomerEmail2', w4,
                    'CustomerMobile11', w1,
                    'CustomerMobile21', w1,
                    'EInvoiceTo', w2,
                    'EInvoiceStatus', w2,
                    'EOrderStatus', w2,
                    'ShippingProviderId', w3,
                    'ShippingAddress1', w1,
                    'ShippingAddress2', w1,
                    'ShippingCity', w1,
                    'ShippingStateId', w3,
                    'ShippingCountry', w1,
                    'ShippingPincode', w5,
                    'EShippingType', w2,
                    'EOrderProcessBy', w2,
                    'EShippingStatus', w2,
                    'ShippingToName', w1,
                    'ExpectedShippingDate', w0,
                    'ShippingNote', w6,
                    'BillingAddress1', w1,
                    'BillingAddress2', w1,
                    'BillingCity', w1,
                    'BillingStateId', w3,
                    'BillingCountry', w1,
                    'BillingPincode', w5,
                    'OrderProducts', w7,
                    'GrossAmount', w8,
                    'DiscountAmount', w8,
                    'NetAmount', w8,
                    'NetAmountAfterFrDiscount', w8,
                    'TaxableAmount', w8,
                    'TaxAmount', w8,
                    'DiscountCoupon', w1,
                    'EFranchiseeDiscountType', w2,
                    'EFranchiseeDiscount', w2,
                    'FranchiseeDiscountValue', w8,
                    'FranchiseeDiscountAmount', w8,
                    'EPaymentStatus', w2,
                    'EPaymentType', w2,
                    'Gstin', w1,
                    'Note', w6,
                    'EmailSendCount', w5,
                    'OrderInstallments', w9,
                    'HasBooks', w10,
                    'MailId', w1,
                    'CurrencyId', w3,
                    'IsEmailSent', w10,
                    'LastEmailSentDate', w0,
                    'FreezeData', w10
                ]);
            }
        }
    }
}
